export function sortByProperty(list, property, first, order = 'asc') {
    const sortedList = [...list].sort((a, b) => {
        const aValue = a[property];
        const bValue = b[property];
        const comparison = String(aValue).localeCompare(String(bValue));
        return order === 'asc' ? comparison : -comparison;
    });
    if (!first)
        return sortedList;
    const filteredList = sortedList.filter(item => JSON.stringify(item) !== JSON.stringify(first));
    return [first, ...filteredList];
}
